// extracted by mini-css-extract-plugin
module.exports = {"path":"StarIcon_path_ZiAHH","filled":"StarIcon_filled_et4yB"};